import React from "react"
import SearchResultTemplate from "@templates/search-results-template"
import { propertyIntro, getSeoDesc } from "@common/utils/property_utils"
import SEO from "@components/seo"

const {
  parseResultsUrl,
} = require("../../gatsby-library-common/PropertySearchNew")

const PropertiesPage = (props) => {
  return <SearchResultTemplate {...props} />
}

export default PropertiesPage

export const Head = (props) => {
  const { location } = props
  // const { pathname } = location
  const pageUrlData = parseResultsUrl(location)

  // let intro = ""
  let metaIntro = ""
  let seoDesc = ""

  if (pageUrlData?.departmentVal) {
    // intro = propertyIntro(pageUrlData, [])
    metaIntro = propertyIntro({ ...pageUrlData, introCopy: true }, [])
    seoDesc = getSeoDesc(pageUrlData, [])
  }

  return (
    <SEO
      title={metaIntro}
      img="https://ggfx-webbers.s3.eu-west-2.amazonaws.com/x.prod/property/BRA220108/images/web/live/pictures/BRA/22/640x/BRA220108_31.webp"
      description={`${seoDesc}`}
    />
  )
}
